const getClosingPeriodStatus = `getClosingStatusPayrollPeriod{ closingPeriod}`;

export default getClosingPeriodStatus;
